import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (shiftEmployee: Employee, value: Value) => {
  const employee = employees.get(shiftEmployee.id)

  if (!employee) return

  switch (value) {
    case 'employee_status':
      return employee

    case 'employee_name': {
      const userId = employee.attributes.access_id
      const user = users.get(userId)
      return user?.fullName()
    }

    case 'location':
      return employee.attributes.location_id

    case 'team':
      return employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)

    case 'legal_entity':
      return employeeLegalEntityId(employee)
  }
}
